export enum DanceClassCommentEnum {
  NONE = "NONE",
  ALL = "ALL",
  FOLLOWER = "FOLLOWER",
  ATTENDEES = "ATTENDEES"
}
